import { PropType } from 'vue'

export const LLM_TAB = {
  ASK_THYME_BOX: 'ask_thyme_box',
  ASK_A_PROFILE: 'ask_a_profile',
  CONNECT_ARTICLES: 'connect_articles',
} as const

export const ASK_LLMS_MODAL_PROPS = {
  isOpen: { type: Boolean, required: true },
  showDevTools: { type: Boolean, required: false, default: false },
  patientId: { type: String, required: false },
  defaultTab: {
    type: String as PropType<LlmTab>,
    required: false,
    default: LLM_TAB.ASK_THYME_BOX,
  },
} as const

export type LlmTab = (typeof LLM_TAB)[keyof typeof LLM_TAB]
